import axios from 'axios';
import config from '../utils/env';

const api = baseUrl => ({
  fetchBlogArticles: async () => {
    const response = await axios({
      url: `${baseUrl}/spaces/${config.contentfulSpaceId}/entries?content_type=blogArticle&order=-sys.createdAt&limit=3`,
      method: 'get',
      headers: {
        Authorization: `Bearer ${config.contentfulAccessToken}`
      }
    });

    return response;
  }
});

export default api(config.contentfulApiRoot);
